module.exports = __webpack_public_path__ + "img/success.271ba59f.png";